import React, { useContext, useEffect, useState } from 'react'

import Context from '../../context'
import ImageUpload from '../LogoUpload'
import TextAreaHtml from '../TextAreaHtml'

import { getThemesList } from '../../services/ClubeApi'

function PartnerData({ userWhiteLabel, userGroup }) {
  const [categoryList, setCategoryList] = useState([
    {
      id: 1,
      title: 'Todas as empresas'
    }
  ])

  const { formObject, setFormObject } = useContext(Context)
  const handleTextArea = value => {
    setFormObject({ ...formObject, description: value })
  }

  const [mainTag, setMainTag] = useState('')

  const defaultProps = {
    options: categoryList,
    getOptionLabel: option => option.title
  }

  useEffect(() => {
    getThemesList()
      .then(response => {
        setCategoryList(response)
        response.map(group => {
          setCategoryList([
            {
              id: 0,
              title: 'Todas as empresas'
            },
            ...group
          ])
        })
      })
      .catch(error => console.log(error))

    // setFormObject({ ...formObject, whiteLabelId: null });
    // console.log(formObject);
  }, [])

  useEffect(() => {
    // const selectecCompany = categoryList?.filter(
    //   item => item.id == formObject.whiteLabelId
    // );
    // setMainTag({ title: selectecCompany[0]?.title });
    const selectecCompany = categoryList?.filter(item => item.id === userWhiteLabel)
    setMainTag(selectecCompany[0]?.title)
  }, [categoryList])

  return (
    <>
      <h5>Informações Sobre o Parceiro</h5>
      <TextAreaHtml
        value={formObject.description || ''}
        handleEditor={handleTextArea}
        placeholder="Descrição do Parceiro"
      />
      <div className="col-12">
        <ImageUpload />
        <ImageUpload cover />
      </div>
    </>
  )
}

export default PartnerData
